import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ClockService } from "src/app/services/clock.service";

@Component({
  selector: "app-countdown",
  templateUrl: "./countdown.component.html",
  styleUrls: ["./countdown.component.scss"],
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input() startDate;
  @Input() endDate;
  @Input() auctionStatus;
  @Input() isAuctionFinishing: boolean = false;

  private serverTimeSubscription: Subscription;

  private serverTime;
  private isAuctionStarted = false;
  private isAuctionFinished = false;
  private countdownValue;

  constructor(private cl: ClockService) {}

  ngOnInit() {
    this.serverTimeSubscription = this.cl.clock.subscribe((item) => {
      this.serverTime = item;
      this.runCountDown();
    });
  }

  runCountDown(): void {
    if (this.startDate > this.serverTime) {
      this.isAuctionStarted = false;
      this.countdownValue = this.startDate;
    } else {
      this.isAuctionStarted = true;

      if (this.serverTime >= this.endDate) {
        this.isAuctionFinished = this.isAuctionFinishing ? false : true;
      } else {
        this.startCountDown();
      }
    }
  }

  startCountDown(): void {
    if (this.serverTime + 1 > this.endDate) {
      this.isAuctionFinished = this.isAuctionFinishing ? false : true;
    } else {
      let diffTime = this.endDate - this.serverTime;
      this.countdownValue = diffTime;
    }
  }

  get isStarted() {
    return this.isAuctionStarted;
  }

  get isFinished() {
    return this.isAuctionFinished;
  }

  get getAuctionStatus() {
    return this.auctionStatus;
  }

  get countdown() {
    return this.countdownValue;
  }

  ngOnDestroy(): void {
    this.serverTimeSubscription.unsubscribe();
  }
}
